import * as yup from "yup";

// This defines the rules for your form
export const profileSettingsSchema = yup.object({
  name: yup
    .string()
    .matches(/^[a-zA-Z\s]*$/, "*Name must only contain letters and spaces") // Allows empty string
    .optional(),
  
  email: yup.string().email("*Invalid email").required("*Email is required"), 
  
  country: yup
    .string()
    .matches(/^[a-zA-Z\s]*$/, "*Country must only contain letters and spaces")
    .optional(),
  
  state: yup
    .string()
    .matches(/^[a-zA-Z\s]*$/, "*State must only contain letters and spaces")
    .optional(),
  
  city: yup
    .string()
    .matches(/^[a-zA-Z\s]*$/, "*City must only contain letters and spaces")
    .optional(),
  
  // --- THIS IS THE FIX ---
  // Gender is now optional, but if it exists, it must be one of these.
  gender: yup
    .string()
    .oneOf(["Male", "Female", "Other", ""], "*Please select a valid gender")
    .optional(), // No longer required
  // --- END OF FIX ---
  
  pin_code: yup
    .string()
    .matches(/^[0-9a-zA-Z-]{4,10}$|^$/, "*Pin Code must be 4-10 digits/letters") // Allows empty string
    .optional(),
});

// This automatically creates the correct TypeScript type from the schema
export type ProfileValidationType = yup.InferType<typeof profileSettingsSchema>;